<script>
	import { onMount } from "svelte";
	import wrappedFetch from "../../wrappedFetch.js";
	import ChangeEstablishment from "./changeestablishment.svelte";
	import Impersonate from "./impersonate.svelte";
	import Router, { route, params, resolveExportUrl } from "../../router.js";
	import { AuthUser } from "../../store.js";
	import {tour} from "../../components/tour.js";

	let showChangeEstablishment = false;
	let showImpersonate = false;
	let impersonate;
	let services = [];

	export let ShowOptions = true;
	export let login = true;
	export let accessDenied = false;
	export let isRegisterPage = false;
	export let isHomePage =false;

	onMount(async()=>{		
		if ($AuthUser != null) {
			let resp = await wrappedFetch('/api/account/GetAppServices', {method: "get"}); 
			services = await resp.json();
			if($AuthUser.universalId.endsWith(".000"))
			{
				if ($AuthUser.firstLogin)
				{
					showChangeEstablishment = true;					
					$AuthUser.firstLogin = false;
					AuthUser.set($AuthUser);
				}
			}
		}
	})

	const stopImpersonate = async()=>{
		let resp = await wrappedFetch(`/api/user/StopImpersonate`,
            {
                method: "post",
            }
        );
		let newUser = await resp.json();
		AuthUser.set(newUser.user);       
        Router.route("/");
	}
</script>

<style>
	@media only screen and (max-width: 767px) {
		.margintopheader {
			margin-top: 16px;
		}
	}
	@media only screen and (min-width: 768px) {
		.margintopheader {
			margin-top: 13px;
		}
	}

	@media only screen and (min-width: 768px) and (max-width: 802px) {
		.d-custom {
			display: none !important;
		}
	}

	.headerfont {
		font-size: 1rem;
	}
</style>

{#if showChangeEstablishment}
	<ChangeEstablishment bind:showModal={showChangeEstablishment} />
{/if}
{#if showImpersonate}
	<Impersonate bind:showModal={showImpersonate} bind:this={impersonate} />
{/if}

<header>
	<nav class="navbar navbar-dark bg-dark fixed-top " id="fixed">
		<div class="d-flex align-items-center">
			<div class="d-block d-md-none" data-toggle="sidebar-colapse">
				<a data-toggle="collapse in" id="menu-toggle" href="#" style="color: #ffffff; padding: 0.25rem 1.5rem 0.25rem 0.25rem;">
					<span class="material-icons">dehaze</span>
					<!-- <span class="fa-stack fa-lg pull-left">
					<i class="fa fa-bars fa-stack-1x" style="color:#ffffff !important" aria-hidden="true"></i></span>-->&nbsp;</a> 
			</div>
			<span class="navbar-brand">
				<a href="/app"><img src="/images/wavenet-education-white.svg" height="50px;" alt="Wavenet Nimbus" /></a>
			</span>

			<div class="dropdown d-none d-sm-block ml-3">
				{#if $AuthUser}
					<a
						href="#"
						class="mr-3 dropdown-toggle"
						style="font-size: 25px; margin-bottom: 0px; color: #ffffff"
						id="dropdownMenuButton"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false">Nimbus
					</a>
					<div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="width: 350px; margin-top: 13px; overflow-x: none">
						<div class="row p-0 m-0" style="max-height: 300px; overflow-y: scroll;">
							{#each services as service}
								<div class="col-4 text-center pb-3">
									<a href={service.url} target="_blank">
										<img src={service.imageUrl} width="50px" alt={service.serviceName} /><br />
										<br />
										{service.serviceName}</a>
								</div>
							{/each}
						</div>
						<div class="row p-0 m-0">
							<div class="col-12 text-center py-2" style="background-color: #f2f2f2">
								<a href="https://apps.adept.education" target="_blank">More Apps</a>
							</div>
						</div>
						<style>
							.dropdown-menu {
								padding-bottom: 0px !important;
							}
						</style>
					</div>
				{:else}
					{#if !isRegisterPage}
						<a href="#"
						class="mr-3"
						style="font-size: 25px; margin-bottom: 0px; color: #ffffff"
						id="dropdownMenuButton"
						data-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false">Wavenet Nimbus</a>
					{:else}
						<a tabindex="0" style="font-size:1rem;color: #ffffff;" href="/">
							<span class="fas fa-arrow-left" />&nbsp;Back
						</a>
					{/if}
				{/if}
			</div>
		</div>
		<div class="form-inline">
			{#if ShowOptions}
				{#if !$AuthUser}
					{#if login && !accessDenied}
						<a
							role="button"
							class="btn btn-dark text-capitalize d-none d-cxxs-none d-md-block"
							href="/app"
							data-bind="hidden: fullName">
							<span class="material-icons">lock</span>
							<span class="headerfont d-none d-md-inline d-md-none d-cxs-none d-csm-none">Login</span>
						</a>
					{:else}
						<a
							role="button"
							class="btn btn-dark text-capitalize d-none d-cxxs-none d-md-block"
							href="/Logout"
							data-bind="hidden: fullName">
							<span class="material-icons">lock</span>
							<span class="headerfont d-none d-md-inline d-md-none d-cxs-none d-csm-none">Logout</span>
						</a>
					{/if}
				{:else}
				{#if isHomePage}
					<button
						class="btn btn-dark text-capitalize d-none d-lg-block headerfont"
						type="button"
						data-toggle="modal"
						data-target=".schoolModal"
						on:click={() => tour.start()}>
						<span class="material-icons">tour</span>
						<span class="headerfont d-none d-md-inline d-lg-none d-custom">Take Tour</span>
						<span class="headerfont d-none d-lg-inline">Take Tour</span>
					</button>
				{/if}
					<button
						class="btn btn-dark text-capitalize d-none d-lg-block headerfont"
						type="button"
						data-toggle="modal"
						data-target=".schoolModal"
						on:click={() => (showChangeEstablishment = true)}>
						<span class="material-icons">swap_horizontal_circle</span>
						<span class="headerfont d-none d-md-inline d-lg-none d-custom">{$AuthUser.establishment}</span>
						<span class="headerfont d-none d-lg-inline">{$AuthUser.establishment}</span>
					</button>
					<a
						class="menu_help btn btn-dark text-capitalize d-none d-lg-block"
						type="button"
						href="/app/help" target="_self">
						<span class="material-icons">help</span>
						<span class="headerfont d-none d-lg-inline">Help</span>
					</a>

					<div class="dropdown" data-bind="visible: fullName">
						<button
							class="btn btn-dark dropdown-toggle text-capitalize"
							type="button"
							id="dropdownMenuButton"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false">
							<span class="material-icons">account_circle</span>
							<span class="headerfont d-none d-md-inline d-cxs-none d-csm-none">{$AuthUser.name}</span>
						</button>
						<button
							href="javascript:;"
							class="dropdown-menu dropdown-menu-right margintopheader"
							aria-labelledby="dropdownMenuButton">
							{#if $AuthUser.schoolId == 18854 &&  !$AuthUser.isImpersonated}
								<a class="dropdown-item" href="javascript:;" on:click={()=>showImpersonate = true}>Impersonate</a>
							{/if}
							{#if $AuthUser.isImpersonated}
								<a class="dropdown-item" href="javascript:;" on:click={async()=> await stopImpersonate()}>Stop Impersonate</a>
							{/if}

							<div class="d-block d-lg-none">
								<a href="#" class="dropdown-item" on:click={() => (showChangeEstablishment = true)}>Change Establishment</a>
							</div>						
							<div class="d-block d-md-none">
								<a href="/app/help" target="_blank" class="dropdown-item">Help</a>
							</div>
							<a class="dropdown-item" href="/Logout">Log out</a>
						</button>
					</div>
				{/if}
			{/if}
		</div>
	</nav>
</header>
